/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type DeleteConfigRequestBody = {
  /**
   * AI provider identifier. Supported values include cursor, anthropic_compliance, codex_compliance, and chatgpt_compliance.
   */
  provider: string;
};

/** @internal */
export type DeleteConfigRequestBody$Outbound = {
  provider: string;
};

/** @internal */
export const DeleteConfigRequestBody$outboundSchema: z.ZodMiniType<
  DeleteConfigRequestBody$Outbound,
  DeleteConfigRequestBody
> = z.object({
  provider: z.string(),
});

export function deleteConfigRequestBodyToJSON(
  deleteConfigRequestBody: DeleteConfigRequestBody,
): string {
  return JSON.stringify(
    DeleteConfigRequestBody$outboundSchema.parse(deleteConfigRequestBody),
  );
}
